import { track } from "@amplitude/unified"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    eventName: String,
    eventProperties: Object,
    threshold: Number,
  }

  connect() {
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
      root: null,
      rootMargin: "0px",
      threshold: this.thresholdValue,
    })

    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer.disconnect()
  }

  handleIntersection(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        track(this.eventNameValue, this.eventPropertiesValue)
      }
    })
  }
}
